import envConfig from '../../static/config';
import config from '../config';
import InternetBankingActions from '../actions/InternetBankingActions';
import ApiUtils from './ApiUtils';

const _getCredentialsEndpoint = '/ibapi/v2/banks/{bank-id}/user/credentials';
const _getSecurityQuestionsEndpoint =
  '/ibapi/v2/banks/{bank-id}/ref/credentials/security_questions';
const _postSecurityQuestionsEndpoint =
  '/ibapi/v2/banks/{bank-id}/user/credentials';
const _getTermsAndConditionsEndpoint = '/ibapi/v2/ref/content/tandcs/B/latest';
const _userAcceptedTandCEndpoint =
  '/ibapi/v2/user/tandcs/{service-name}/{version}/accept';

const UserServicesApiUtils = {
  /**
   * What services is this user registered for?
   * @todo consider renaming to `getUserCredentials()` for clarity.
   */
  getCredentials() {
    let url = envConfig.apiBaseUrlPAAS + _getCredentialsEndpoint;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.authenticationStub.GetCredentialsConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.userCredentialServices,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        InternetBankingActions.updateFormValue('credentials', body.credentials);
      }
    );
  },

  /**
   * Get the security questions from the user services API.
   */
  requestSecurityQuestions() {
    let url = envConfig.apiBaseUrlPAAS + _getSecurityQuestionsEndpoint;
    if (envConfig.stubConfig) {
      url =
        envConfig.stubConfig.authenticationStub.GetSecurityQuestionsConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.userCredentialServices,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        InternetBankingActions.updateFormValue(
          'securityQuestions',
          body.security_questions
        );
      }
    );
  },

  /**
   * Submit the security questions, answers, and telephone pin
   *
   * @param  {Object} securityQuestions    The security questions, answers, and telephone pin
   * @param {String} nextWebTask        Next web task based on product post registration task.
   */
  submitSecurityQuestions(options, nextWebTask) {
    let url = envConfig.apiBaseUrlPAAS + _postSecurityQuestionsEndpoint;
    let method = 'PUT';
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.authenticationStub.GetCredentialsConnection;
      method = 'GET';
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.userCredentialServices,
        method,
        url,
        addAuthToken: true,
        requestData: options.registrationData,
        publicKeyMethod: options.publicKeyMethod,
      },
      () => {
        // Currently this only sends back a 200 so all we can do for now is go to next web task frmo product.
        InternetBankingActions.navigateToWebTask(nextWebTask);
      },
      (body, status) => {
        if (options.errorCallback && status === 409) {
          options.errorCallback(body);
        } else {
          InternetBankingActions.navigateToWebTask('WEB-ERROR');
        }
      }
    );
  },

  getTermsAndConditionsDetails() {
    const url = envConfig.apiBaseUrlPAAS + _getTermsAndConditionsEndpoint;
    const method = 'GET';
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.userServices,
        method,
        url,
        addAuthToken: true,
      },
      (body) => {
        InternetBankingActions.handleTermsAndConditionsSuccess(body);
      },
      (error) => {
        InternetBankingActions.navigateToWebTask('WEB-ERROR');
      }
    );
  },

  acceptedTermsAndConditions(serviceName, version) {
    let url = envConfig.apiBaseUrlPAAS + _userAcceptedTandCEndpoint;
    url = url.replace('{service-name}', serviceName);
    url = url.replace('{version}', version);
    const method = 'PUT';
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.userServices,
        method,
        url,
        addAuthToken: true,
      },
      (body) => {
        // Currently this only sends back a 200 so all we can do for now is go to next web task frmo product.
      },
      (error) => {
        InternetBankingActions.navigateToWebTask('WEB-ERROR');
        // }
      }
    );
  },
};

export default UserServicesApiUtils;
